import { DocumentType } from "./DocumentType";
export class TaskTypeDocument {
    Id: number;
    DocumentTypeId: number;
    DocumentType: DocumentType;
    Mandatory: boolean;
}